export default "__VITE_ASSET__BAgh2fcW__"